<template>
  <div class="mx-3 mx-md-0">
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="text-center text-uppercase font-weight-bold">
          Dashboard &#x1F4C8;
        </h1>
      </div>
    </div>
    <div>
      <hr class="" />
    </div>
    <div class="d-flex justify-content-around">
      <div>
        <label class="font-weight-bold fs-20">
          <span> Total lojista cadastrados: &nbsp; </span>
          <span class="badge bg-orange c-white p-2">
            {{ totalShopkeeper }}
          </span>
        </label>
      </div>
      <div>
        <label class="font-weight-bold fs-20">
          <span> Valor total acumulado: &nbsp; </span>
          <span class="badge bg-orange c-white p-2">
            R${{ totalSales }},00
          </span>
        </label>
      </div>
    </div>
    <div>
      <hr class="" />
    </div>
    <b-row
      class="align-items-center justify-content-center"
      v-if="this.loadedData"
    >
      <b-col cols="12">
        <LineChart :chartdata="salesChart" :options="chartOptions" />
      </b-col>
    </b-row>
    <div>
      <hr class="" />
    </div>
    <b-row
      class="align-items-center justify-content-center"
      v-if="this.loadedData"
    >
      <b-col cols="12">
        <LineChart :chartdata="shopkeepersChart" :options="chartOptions" />
      </b-col>
    </b-row>
    <canvas v-show="false" ref="gradientCanvas"></canvas>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import LineChart from './Chart/LineChart.vue';

export default {
  name: 'Dashboard',
  components: {
    LineChart,
  },
  data: () => ({
    loadedData: false,
    totalSales: '',
    totalShopkeeper: '',
    gradient: {
      salesReceveid: null,
      salesToReceve: null,
      shopkeepersRegistered: null,
      orcamentsByShopkeepers: null,
      salesByShopkeepers: null,
    },
    salesChart: {
      labels: ['Todo o período', '60 dias', '30 dias', '7 dias'],
      datasets: [
        {
          label: 'Vendas recebidas (R$)',
          borderColor: '#25d366',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: 'white',
          backgroundColor: null,
          data: [],
        },
      ],
    },
    shopkeepersChart: {
      labels: ['Todo o período', '60 dias', '30 dias', '7 dias'],
      datasets: [
        {
          label: 'Lojistas cadastrados',
          borderColor: '#25d366',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: 'white',
          backgroundColor: null,
          data: [],
        },
        {
          label: 'Orçamentos respondidos pelo lojista',
          borderColor: '#f2d608',
          pointBackgroundColor: 'yellow',
          borderWidth: 1,
          pointBorderColor: 'yellow',
          backgroundColor: null,
          data: [],
        },
        {
          label: 'Vendas realizadas pelo lojista',
          borderColor: '#0079ff',
          pointBackgroundColor: 'blue',
          borderWidth: 1,
          pointBorderColor: 'blue',
          backgroundColor: null,
          data: [],
        },
      ],
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  computed: {
    ...mapState(['dadosUsuario']),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.getDashboardData({ partnerId: this.dadosUsuario.informacoes.id })
      .then((response) => {
        this.setSalesReceivedChartData(response.data.salesReceived);
        this.totalSales = response.data.salesReceived.allPeriod;
        this.setShopkeepersRegisteredChartData(
          response.data.shopkeepersRegistered
        );
        this.totalShopkeeper = response.data.shopkeepersRegistered.allPeriod;
        this.setShopkeepersProcessingChartData(
          response.data.answerByShopkeepers
        );
        this.setShopkeepersRejectedChartData(response.data.salesByShopkeepers);
        this.loadedData = true;
        this.defineGradient();
      })
      .finally(() => this.$store.dispatch('endLoader'));
  },
  methods: {
    ...mapActions('partner', ['getDashboardData']),
    setSalesReceivedChartData(salesReceived) {
      Object.entries(salesReceived).forEach(([key, value]) => {
        this.salesChart.datasets[0].data.push(parseInt(value, 10));
      });
    },
    setShopkeepersRegisteredChartData(shopkeepersRegistered) {
      Object.entries(shopkeepersRegistered).forEach(([key, value]) => {
        this.shopkeepersChart.datasets[0].data.push(parseInt(value, 10));
      });
    },
    setShopkeepersProcessingChartData(answerByShopkeepers) {
      Object.entries(answerByShopkeepers).forEach(([key, value]) => {
        this.shopkeepersChart.datasets[1].data.push(parseInt(value, 10));
      });
    },
    setShopkeepersRejectedChartData(salesByShopkeepers) {
      Object.entries(salesByShopkeepers).forEach(([key, value]) => {
        this.shopkeepersChart.datasets[2].data.push(parseInt(value, 10));
      });
    },
    defineGradient() {
      this.gradient.salesReceived = this.$refs.gradientCanvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450);

      this.gradient.answerByShopkeepers = this.$refs.gradientCanvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450);

      this.gradient.salesByShopkeepers = this.$refs.gradientCanvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 450);

      this.gradient.salesReceived.addColorStop(0, 'rgba(37, 211, 102, 0.5)');
      this.gradient.salesReceived.addColorStop(0.5, 'rgba(37, 211, 102, 0.25)');
      this.gradient.salesReceived.addColorStop(1, 'rgba(37, 211, 102, 0)');

      this.gradient.salesByShopkeepers.addColorStop(0, 'rgba(0, 0, 255, 1)');
      this.gradient.salesByShopkeepers.addColorStop(
        0.5,
        'rgba(0, 0, 255, 0.25)'
      );
      this.gradient.salesByShopkeepers.addColorStop(1, 'rgba(0, 0, 255, 0)');

      this.gradient.answerByShopkeepers.addColorStop(
        0,
        'rgba(242, 214, 8, 0.9)'
      );
      this.gradient.answerByShopkeepers.addColorStop(
        0.5,
        'rgba(242, 214, 8, 0.25)'
      );
      this.gradient.answerByShopkeepers.addColorStop(1, 'rgba(242, 214, 8, 0)');

      this.salesChart.datasets[0].backgroundColor = this.gradient.salesReceived;
      this.shopkeepersChart.datasets[0].backgroundColor =
        this.gradient.salesReceived;
      this.shopkeepersChart.datasets[1].backgroundColor =
        this.gradient.answerByShopkeepers;
      this.shopkeepersChart.datasets[2].backgroundColor =
        this.gradient.salesByShopkeepers;
    },
  },
};
</script>
